import { ApplicationCardStatusType } from "./../enums/ApplicationCardStatusType"
import { DriverLicenseCategoriesType } from "./../flags/DriverLicenseCategoriesType"

export default interface IDriverLicenseVm {
    id: string
    number: string
    base64FrontImage: string
    base64BackImage: string
    cardStatus: ApplicationCardStatusType
    isLicenseForeign: boolean
    issueDate: string
    chosenLicenseCategories: DriverLicenseCategoriesType
    isDriverLicenseFrontImageModified: boolean
    isDriverLicenseBackImageModified: boolean
    hasValidLicense: boolean
}

export const empty = (enableIteration: boolean = true): IDriverLicenseVm => {
	return {
		id: "",
		number: "",
		base64FrontImage: "",
		base64BackImage: "",
		cardStatus: ApplicationCardStatusType.NotSet,
		isLicenseForeign: false,
		issueDate: "",
		chosenLicenseCategories: DriverLicenseCategoriesType.NotSet,
		isDriverLicenseFrontImageModified: false,
		isDriverLicenseBackImageModified: false,
		hasValidLicense: false
	} as IDriverLicenseVm
}